import ApiSetting from '@/request/api/setting'
import axios from '@/request/http'
import querystring from 'querystring'

const todayRecommendApi = {
  list (params) {
    return axios.get(
      `${ApiSetting.baseUrl}/api/todayrecommends/`,
      {params: params})
  },
  detail (todayRecommendId, params) {
    return axios.get(
      `${ApiSetting.baseUrl}/api/todayrecommends/${todayRecommendId}/`,
      {params: params})
  },
  create (params) {
    // 创建新主题
    // return axios.post(
    //   `${ApiSetting.baseUrl}/api/todayrecommends/`, querystring.stringify(params))
    return axios.post(
      `${ApiSetting.baseUrl}/api/todayrecommends/`, querystring.stringify(params))
  },
  update (todayRecommendId, params) {
    // 更新主题
    // return axios.post(
    //   `${ApiSetting.baseUrl}/api/todayrecommends/`, querystring.stringify(params))
    return axios.put(
      `${ApiSetting.baseUrl}/api/todayrecommends/${todayRecommendId}/`, querystring.stringify(params))
  },
  delete (todayRecommendId) {
    window.console.log("发起删除请求")
    return axios.delete(
      `${ApiSetting.baseUrl}/api/todayrecommends/${todayRecommendId}/`
    )
  }
}

export default todayRecommendApi
